import { useTranslations } from 'next-intl';
import styles from './MerchClothingSizingModal.module.css';

export const MerchClothingSizingModal = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('common');
  const sizingData = [
    { size: 'XS', chest: '36', length: '26.5' },
    { size: 'S', chest: '38', length: '27' },
    { size: 'M', chest: '40', length: '27.5' },
    { size: 'L', chest: '42', length: '28' },
    { size: 'XL', chest: '44', length: '29' },
    { size: 'XXL', chest: '46', length: '29.5' },
  ];

  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      <div className={styles.header}>
        <h2 className={styles.title}>{t('merchClothingSizingModal.title')}</h2>
        <p className={styles.subtitle}>
          {t('merchClothingSizingModal.subtitle')}
        </p>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.sizingTable}>
          <thead>
            <tr>
              <th>{t('merchClothingSizingModal.size')}</th>
              <th>{t('merchClothingSizingModal.chest')}</th>
              <th>{t('merchClothingSizingModal.length')}</th>
            </tr>
          </thead>
          <tbody>
            {sizingData.map((item, index) => (
              <tr
                key={item.size}
                className={index % 2 === 0 ? styles.even : styles.odd}
              >
                <td className={styles.sizeCell}>{item.size}</td>
                <td>{item.chest}&quot;</td>
                <td>{item.length}&quot;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
